import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';


@Component({
  selector: 'time-input',
  templateUrl: 'time-input.html'
})
export class TimeInput {

  @Input() label: string;
  @Input() time: string;
  @Output() timeChange: any = new EventEmitter();

  @ViewChild('timeInput') timeInput : HTMLInputElement;


  onTime(time: string) {
		this.time = this.parseGermanTime(time);
    //Text nochmal überschreiben, wenn sich der Wert im Textfeld, aber nicht
    //im Modell geändert hat. z.B. würde die Änderung von "9:00" auf "09:00"
    //nicht im Modell als Änderung wahrgenommen werden.
    if (this.time != this.timeInput.value)
      this.timeInput.value = this.time;
    this.timeChange.emit(this.time);
	}

	/**
	 * Versucht eine Uhrzeit im Format "hh:mm" aus dem gegebenen
	 * String zu bauen. Fehlt die Minute oder ist ungültig, wird 0 verwendet.
   * Ist auch die Stunde ungültig, wird der leere String zurückgegeben.
   * Als Trennzeichen wird auch "." und "," akzeptiert.
   * Ebenso wird ohne Trennzeichen (z.B. 930 als 9:30 oder 1245 als 12:45)
   * akzeptiert.
	 */
	parseGermanTime(input : string) : string {
		if (input == undefined)
			return "";
    input = input.replace(/\./g, ':');
    input = input.replace(/,/g, ':');
		let parts = input.split(":");
    //Format "930" oder "1245"?
    if (parts.length == 1 && (parts[0].length == 3 || parts[0].length == 4)) {
      parts = [parts[0].substr(0, parts[0].length - 2), parts[0].substr(parts[0].length - 2)];
    }
		//Stunde
		let hour = parseInt(parts[0]);
		if (isNaN(hour) || hour < 0)
			return "";
    if (hour > 24)
      hour = 0;
		//Minute
		let minute = 0;
		if (parts.length >= 2 && false == isNaN(parseInt(parts[1])))
			minute = parseInt(parts[1]);
		if (minute < 0 || minute > 59)
      minute = 0;
		//Formatieren
		let sHour = hour.toString(); if (sHour.length == 1) sHour = "0" + sHour;
    let sMinute = minute.toString(); if (sMinute.length == 1) sMinute = "0" + sMinute;
		return sHour + ":" + sMinute;
	}

}



// WEBPACK FOOTER //
// ./src/components/time-input/time-input.component.ts